<template>
    <div class="company">
        <el-row class="headee">
            <el-col :span="5">
                <div></div>
            </el-col>
            <el-col :span="14" class="center">
                <img src="../assets/images/u16.png" class="h-i" />
            </el-col>
            <el-col :span="5">
                <div class="flex">
                    <img src="../assets/images/u19.png" class="i100" />
                    <div class="phone">
                        <span>联系电话</span>
                        <span>0531-66680626</span>
                    </div>
                </div>
            </el-col>
        </el-row>
        <div class="bgg">
            <div class="blue"></div>
            <img src="../assets/images/背景_u1.png" alt="" class="img-bg" />
            <img
                src="../assets/images/u12_state0.png"
                alt=""
                class="img-bg-line"
            />
            <el-row>
                <!-- <el-col :span="14" :offset="5"> -->
                <div class="content">
                    <div class="relative">
                        <p class="title center">山东省易制毒化学品管理协会</p>

                        <div class="white mt-40">
                            <el-tabs
                                class="tabss"
                                v-model="activeName"
                                type="card"
                                @tab-click="handleClick"
                            >
                                <el-tab-pane
                                    label="入会申请表"
                                    name="apply"
                                ></el-tab-pane>
                                <el-tab-pane
                                    label="会员编码查询"
                                    name="search"
                                ></el-tab-pane>
								<el-tab-pane
								    label="报名入口"
								    name="train"
								></el-tab-pane>
                            </el-tabs>
                            <el-form
                                v-show="activeName === 'apply'"
                                :model="ruleForm"
                                :rules="rules"
                                ref="ruleForm"
                                label-width="100px"
                                class="demo-ruleForm"
                                label-position="top"
                            >
                                <el-form-item label="1.公司名称" prop="gsmc">
                                    <el-input
                                        maxlength="100"
                                        v-model="ruleForm.gsmc"
                                        style="width: 300px"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="2.统一信用代码（税号）"
                                    prop="tyshxydm"
                                >
                                    <el-input
                                        maxlength="50"
                                        v-model="ruleForm.tyshxydm"
                                        style="width: 300px"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="3.单位性质" prop="dwxz">
                                    <el-select
                                        v-model="ruleForm.dwxz"
                                        placeholder="请选择单位性质"
                                        style="width: 300px"
                                    >
                                        <el-option
                                            v-for="(item, index) in xingzhi"
                                            :key="index"
                                            :label="item"
                                            :value="item"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="4.单位类型" prop="dwlx">
                                    <el-select
                                        v-model="ruleForm.dwlx"
                                        placeholder="请选择单位类型"
                                        style="width: 300px"
                                    >
                                        <el-option
                                            v-for="(item, index) in leixing"
                                            :key="index"
                                            :label="item"
                                            :value="item"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="5.成立时间" prop="clsj">
                                    <el-date-picker
                                        type="date"
                                        placeholder="选择成立时间"
                                        v-model="ruleForm.clsj"
                                        style="width: 300px"
                                        value-format="yyyy-MM-dd"
                                    ></el-date-picker>
                                </el-form-item>
                                <el-form-item
                                    label="6.注册资金（万元）"
                                    prop="zczj"
                                >
                                    <el-input
                                        maxlength="10"
                                        v-model.number="ruleForm.zczj"
                                        style="width: 300px"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="7.所属公安局"
                                    prop="region"
                                >
                                    <el-cascader
                                        :props="xzqhprops"
                                        placeholder="请选择所属公安局"
                                        v-model="ruleForm.region"
                                        style="width: 300px"
                                        ref="refRegion"
                                        @change="selectCascader()"
                                    ></el-cascader>
                                </el-form-item>
                                <el-form-item label="8.企业类型【多选题】">
                                    <el-checkbox-group v-model="ruleForm.ywlx">
                                        <el-checkbox label="生产"
                                            >生产</el-checkbox
                                        >
                                        <el-checkbox label="经营"
                                            >经营</el-checkbox
                                        >
                                        <el-checkbox label="使用"
                                            >使用</el-checkbox
                                        >
                                        <el-checkbox label="运输"
                                            >运输</el-checkbox
                                        >
                                        <el-checkbox label="进口"
                                            >进口</el-checkbox
                                        >
                                        <el-checkbox label="出口"
                                            >出口</el-checkbox
                                        >
                                    </el-checkbox-group>
                                </el-form-item>
                                <el-form-item label="9.法人姓名" prop="frxm">
                                    <el-input
                                        maxlength="50"
                                        v-model="ruleForm.frxm"
                                        style="width: 300px"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="10.联系方式" prop="lxdh">
                                    <el-input
                                        maxlength="15"
                                        v-model.number="ruleForm.lxdh"
                                        style="width: 300px"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="11.联络人姓名"
                                    prop="lxrxm"
                                >
                                    <el-input
                                        maxlength="50"
                                        v-model="ruleForm.lxrxm"
                                        style="width: 300px"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="12.联络人联系方式"
                                    prop="lxrdh"
                                >
                                    <el-input
                                        maxlength="15"
                                        v-model.number="ruleForm.lxrdh"
                                        style="width: 300px"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="13.单位通讯地址">
                                    <el-input
                                        maxlength="200"
                                        v-model="ruleForm.dwtxdz"
                                        style="width: 300px"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="14.单位电话" prop="dwdh">
                                    <el-input
                                        maxlength="15"
                                        v-model="ruleForm.dwdh"
                                        style="width: 300px"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="15.单位传真">
                                    <el-input
                                        maxlength="15"
                                        v-model.number="ruleForm.dwcz"
                                        style="width: 300px"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="16.邮箱" prop="email">
                                    <el-input
                                        maxlength="100"
                                        v-model="ruleForm.email"
                                        style="width: 300px"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="17.企业经营范围"
                                    prop="qyjyfw"
                                >
                                    <el-input
                                        type="textarea"
                                        maxlength="1000"
                                        placeholder="企业经营范围1000字以内"
                                        v-model="ruleForm.qyjyfw"
                                        rows="6"
                                        style="width: 300px"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="18.申请会员等级"
                                    prop="sqhydj"
                                >
                                    <el-radio-group v-model="ruleForm.sqhydj">
                                        <el-radio label="免费会员"
                                            >免费会员</el-radio
                                        >
                                        <el-radio label="普通会员"
                                            >普通会员</el-radio
                                        >
                                        <el-radio label="理事会员"
                                            >理事会员</el-radio
                                        >
                                        <el-radio label="会长单位"
                                            >会长单位</el-radio
                                        >
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item>
                                    <div class="center">
                                        <el-button
                                            class="aaaa"
                                            size="medium"
                                            type="primary"
                                            @click="submitForm('ruleForm')"
                                            :loading="btnLoading"
                                            >提交</el-button
                                        >
                                    </div>
                                </el-form-item>
                                <el-form-item label="" prop="xzqy">
                                    <a
                                        href="省协会会员服务方案（试行）.pdf"
                                        target="_blank"
                                        >下载《会员权益》</a
                                    >
                                </el-form-item>
                            </el-form>
                            <el-form
                                v-show="activeName === 'search'"
                                :model="searchForm"
                                ref="searchForm"
                                label-width="100px"
                                class="demo-ruleForm"
                                label-position="top"
                            >
                                <el-form-item label="1.公司名称" prop="gsmc">
                                    <el-input
                                        maxlength="100"
                                        v-model="searchForm.gsmc"
                                        style="width: 300px"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="2.统一信用代码（税号）"
                                    prop="tyshxydm"
                                >
                                    <el-input
                                        maxlength="50"
                                        v-model="searchForm.tyshxydm"
                                        style="width: 300px"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="3.联络人联系方式"
                                    prop="lxrdh"
                                >
                                    <el-input
                                        maxlength="15"
                                        v-model.number="searchForm.lxrdh"
                                        style="width: 300px"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <div class="center">
                                        <el-button
                                            class="aaaa"
                                            size="medium"
                                            type="primary"
                                            @click="searchHandle('searchForm')"
                                            :loading="btnLoading"
                                            >查询</el-button
                                        >
                                    </div>
                                </el-form-item>
                            </el-form>
							<el-form
							    v-show="activeName === 'train'&&trainsOption.length"
							    :model="trainForm"
							    :rules="rulesTrain"
							    ref="trainForm"
							    label-width="100px"
							    label-position="top"
							>
								<el-form-item label="1.参与培训/会议场次" prop="trainId">
								    <el-select
								        v-model="trainForm.trainId"
								        placeholder="请选择参与培训/会议场次"
								        style="width: 300px"
								    >
								        <el-option
								            v-for="(item, index) in trainsOption"
								            :key="index"
								            :label="item.name"
								            :value="item.id"
								        ></el-option>
								    </el-select>
								</el-form-item>
							    <el-form-item label="2.参会单位名称" prop="gsmc">
							        <el-input
							            maxlength="100"
							            v-model="trainForm.gsmc"
							            style="width: 300px"
							        ></el-input>
							    </el-form-item>
							    <el-form-item
							        label="3.统一社会信用代码"
							        prop="tyshxydm"
							    >
							        <el-input
							            maxlength="50"
							            v-model="trainForm.tyshxydm"
							            style="width: 300px"
							        ></el-input>
							    </el-form-item>
							    <el-form-item
							        label="4.所属地区"
							        prop="region"
							    >
							        <el-cascader
							            :props="xzqhprops"
							            placeholder="请选择所属地区"
							            v-model="trainForm.region"
							            style="width: 300px"
							            ref="refRegionTrain"
							            @change="selectCascaderTrain()"
							        ></el-cascader>
							    </el-form-item>
								<el-form-item label="5.单位通讯地址" prop="gsaddr">
									<el-input
										maxlength="50"
										v-model="trainForm.gsaddr"
										style="width: 300px"
									></el-input>
								</el-form-item>
								<el-form-item label="6.参会人数(如参会人数大于2人，请将参会人姓名及联系方式写在备注中)" prop="joinNum">
								    <el-input
								        maxlength="3"
								        v-model.number="trainForm.joinNum"
										:min="1"
								        style="width: 300px"
								    ></el-input>
								</el-form-item>
							    <el-form-item label="7.参会人1(姓名)" prop="joinOne">
							        <el-input
							            maxlength="50"
							            v-model="trainForm.joinOne"
							            style="width: 300px"
							        ></el-input>
							    </el-form-item>
							    <el-form-item label="8.联系电话" prop="joinOneMobile">
							        <el-input
							            maxlength="15"
							            v-model.number="trainForm.joinOneMobile"
							            style="width: 300px"
							        ></el-input>
							    </el-form-item>
							    <el-form-item label="9.参会人2(姓名)" prop="joinTwo">
							        <el-input
							            maxlength="50"
							            v-model="trainForm.joinTwo"
							            style="width: 300px"
							        ></el-input>
							    </el-form-item>
							    <el-form-item label="10.联系电话" prop="joinTwoMobile">
							        <el-input
							            maxlength="15"
							            v-model.number="trainForm.joinTwoMobile"
							            style="width: 300px"
							        ></el-input>
							    </el-form-item>
							    <el-form-item label="11.开票单位抬头" prop="voteHead">
							        <el-input
							            maxlength="200"
							            v-model="trainForm.voteHead"
							            style="width: 300px"
							        ></el-input>
							    </el-form-item>
							    <el-form-item label="12.开票单位统一社会信用代码" prop="voteTyshxydm">
							        <el-input
							            maxlength="50"
							            v-model="trainForm.voteTyshxydm"
							            style="width: 300px"
							        ></el-input>
							    </el-form-item>
								<el-form-item label="13.票据接收邮箱" prop="voteReceiverEmail">
								    <el-input
								        maxlength="100"
								        v-model="trainForm.voteReceiverEmail"
								        style="width: 300px"
								    ></el-input>
								</el-form-item>
							    <el-form-item label="14.备注（如对开票有特殊要求请进行备注）" prop="remark">
							        <el-input
							            maxlength="200"
							            v-model="trainForm.remark"
							            style="width: 300px"
							        ></el-input>
							    </el-form-item>
							    <el-form-item>
							        <div class="center">
							            <el-button
							                class="aaaa"
							                size="medium"
							                type="primary"
							                @click="submitTrainForm('trainForm')"
							                :loading="btnLoading"
							                >提交</el-button
							            >
							        </div>
							    </el-form-item>
							</el-form>
                            <div class="trains-no-data" v-show="activeName === 'train'&&!trainsOption.length">
                                暂无培训场次，请等待培训通知
                            </div>
                        </div>
                    </div>
                </div>
                <!-- </el-col> -->
            </el-row>
        </div>
        <el-row class="bottomm">
            <el-col :span="5" :offset="2">
                <div class="bottomm aasdas">
                    <span>Copyright © 山东省易制毒化学品管理协会</span>
                </div>
            </el-col>
            <el-col :span="5" :offset="6">
                <div class="bottomm aasdas aln">
                    <div class="er-code-box">
                        <img
                            src="../assets/images/u10.png"
                            alt=""
                            class="er-code"
                        />
                        <span>公众号</span>
                    </div>
                    <div class="er-code-box">
                        <img
                            src="../assets/images/u8.png"
                            alt=""
                            class="er-code"
                        />
                        <span>企业微信</span>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-dialog :visible.sync="dialogVisible" width="400px">
            <p class="center a1">恭喜您注册成功!</p>
            <p class="center a2">
                您的会员编号是：<span> {{ respCode }}</span
                >,请妥善保存
            </p>
            <p class="center a3">如有疑问可以随时拨打电话：0531-66680626</p>
            <div slot="footer" class="dialog-footer center">
                <el-button type="primary" @click="goBack" style="width: 200px"
                    >返回首页</el-button
                >
            </div>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisibleSearch" width="400px">
            <p class="center a2">
                您的会员编号是：<span> {{ respCode }}</span>
            </p>
            <p class="center a2">请妥善保存</p>
            <p class="center a3">如有疑问可以随时拨打电话：0531-66680626</p>
            <div slot="footer" class="dialog-footer center">
                <el-button type="primary" @click="goBack" style="width: 200px"
                    >返回首页</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from "axios";
export default {
    name: "register",
    data() {
        return {
            activeName: "apply",
            dialogVisible: false,
            dialogVisibleSearch: false,
            respCode: "",
            btnLoading: false,
            xzqhprops: null, //行政区划
			trainsOption:[],
            xingzhi: [
                "企业",
                "党政机关",
                "事业单位",
                "部队单位",
                "社会团体",
                "分公司",
                "其他",
            ],
            leixing: [
                "国有企业",
                "集体企业",
                "股份合作企业",
                "联营企业",
                "有限责任公司",
                "股份有限公司",
                "私营企业",
                "港、澳、台商投资企业",
                "其他",
            ],
			trainForm: {
			    gsmc: "",
			    tyshxydm: "",
			    joinOne: "",
			    joinOneMobile: "",
			    joinTwo: "",
			    joinTwoMobile: "",
			    region: "",				
				province: "",
				city: "",
				county: "",
				gsaddr: "",
			    voteHead: "",
			    voteTyshxydm: "",
			    voteReceiverEmail: "",
			    remark: "",
			},
            ruleForm: {
                gsmc: "",
                tyshxydm: "",
                dwxz: "",
                dwlx: "",
                clsj: "",
                zczj: "",
                region: "",
                ywlx: [],
                frxm: "",
                lxdh: "",
                lxrxm: "",
                lxrdh: "",
                dwtxdz: "",
                dwdh: "",
                dwcz: "",
                email: "",
                qyjyfw: "",
                sqhydj: "",
                province: "",
                city: "",
                county: "",
            },
            searchForm: {
                lxrdh: "",
                tyshxydm: "",
                gsmc: "",
            },
            rules: {
                gsmc: [
                    {
                        required: true,
                        message: "请输入公司名称",
                        trigger: "blur",
                    },
                ],
                tyshxydm: [
                    {
                        required: true,
                        message: "请输入统一信用代码（税号）",
                        trigger: "blur",
                    },
                ],
                dwxz: [
                    {
                        required: true,
                        message: "请选择单位性质",
                        trigger: "change",
                    },
                ],
                dwlx: [
                    {
                        required: true,
                        message: "请选择单位类型",
                        trigger: "change",
                    },
                ],
                clsj: [
                    {
                        required: true,
                        message: "请选择成立时间",
                        trigger: "change",
                    },
                ],
                region: [
                    {
                        required: true,
                        message: "请选择所属区县",
                        trigger: "change",
                    },
                ],
                zczj: [
                    {
                        required: true,
                        message: "请输入注册资金",
                        trigger: "blur",
                    },
                    { type: "number", message: "注册资金必须为数字值" },
                ],
                frxm: [
                    {
                        required: true,
                        message: "请输入法人姓名",
                        trigger: "blur",
                    },
                ],
                lxdh: [
                    {
                        required: true,
                        message: "请输入联系方式",
                        trigger: "blur",
                    },
                ],

                lxrxm: [
                    {
                        required: true,
                        message: "请输入联络人姓名",
                        trigger: "blur",
                    },
                ],
                lxrdh: [
                    {
                        required: true,
                        message: "请输入联络人联系方式",
                        trigger: "blur",
                    },
                ],
                dwdh: [
                    {
                        required: true,
                        message: "请输入单位电话",
                        trigger: "blur",
                    },
                ],
                email: [
                    {
                        required: true,
                        message: "请输入邮箱地址",
                        trigger: "blur",
                    },
                    {
                        type: "email",
                        message: "请输入正确的邮箱地址",
                        trigger: ["blur", "change"],
                    },
                ],
                qyjyfw: [
                    {
                        required: true,
                        message: "请输入经营范围",
                        trigger: "blur",
                    },
                ],
                sqhydj: [
                    {
                        required: true,
                        message: "请选择会员等级",
                        trigger: "change",
                    },
                ],
            },
			rulesTrain: {
				trainId: [
                    {
                        required: true,
                        message: "请选择培训场次",
                        trigger: "change",
                    },
                ],
                gsmc: [
                    {
                        required: true,
                        message: "请输入公司名称",
                        trigger: "blur",
                    },
                ],
                tyshxydm: [
                    {
                        required: true,
                        message: "请输入统一信用代码（税号）",
                        trigger: "blur",
                    },
                ],
				region: [
				    {
				        required: true,
				        message: "请选择所属区县",
				        trigger: "change",
				    },
				], 
				gsaddr: [
				    {
				        required: true,
				        message: "请输入单位通讯地址",
				        trigger: "blur",
				    },
				],
				joinNum: [
				    {
				        required: true,
				        message: "请输入参会人数",
				        trigger: "blur",
				    },
				],
                joinOne: [
                    {
                        required: true,
                        message: "请输入参会人1",
                        trigger: "blur",
                    },
                ],
                joinOneMobile: [
                    {
                        required: true,
                        message: "请输入联系方式",
                        trigger: "blur",
                    },
                ],
                voteHead: [
                    {
                        required: true,
                        message: "请输入开票单位抬头",
                        trigger: "blur",
                    },
                ],
				voteTyshxydm: [
				    {
				        required: true,
				        message: "请输入开票单位统一社会信用代码",
				        trigger: "blur",
				    },
				],
				voteReceiverEmail: [
				    {
				        required: true,
				        message: "请输入票据接收邮箱",
				        trigger: "blur",
				    },
				    {
				        type: "email",
				        message: "请输入正确的票据接收邮箱",
				        trigger: ["blur", "change"],
				    },
				],                              
            },
        };
    },
    computed: {},
    created() {
        this.xzqhprops = {
            lazy: true,
            lazyLoad: (node, resolve) => {
                let query = { parentId: 0 };
                console.log(node, "node");
                if (node && node.value) {
                    query.parentId = node.value;
                }
                this.$get(
                        `visitor/xzqh/list?parentId=${query.parentId}`
                    )
                    .then((res) => {
                        const nodes = res.data.data.map((item) => ({
                            value: item.id,
                            label: item.label,
                            leaf: !item.leaf,
                            level: item.level,
                        }));
                        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                        resolve(nodes);
                    });
            },
        };

		// axios.get(`https://test.xhmember.sdeast8.com/prod-api/biz/train/listAll`)
		//     .then((res) => {
		// 		this.trainsOption = res.data.data;
		// 	});
        this.$get('biz/train/listAll').then(res=>{
            this.trainsOption = res.data.data;
        })
    },
    methods: {
		submitTrainForm(formName) {
                        // this.$refs[formName].resetFields()
			this.$refs[formName].validate(async (valid) => {
			    if (valid) {
					let trainForm = JSON.parse(JSON.stringify(this.trainForm));
					trainForm.region = trainForm.regionStr;
					this.btnLoading = true;
					const resp = await this.$post(
					    `biz/trainSignup/apply`,
					    trainForm
					);
					this.btnLoading = false;
					if (resp.data.code === 200) {
					    this.$message.success("报名成功")
                        this.$refs[formName].resetFields()
					} else {
					    this.$message.error(resp.data.msg);
					}
				} else {
					return false;
				}
			})
		},
        submitForm(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
                    ruleForm.ywlx = ruleForm.ywlx.join(",");
                    ruleForm.region = ruleForm.regionStr;
                    this.btnLoading = true;
                    const resp = await this.$post(
                        `visitor/joinxh/apply`,
                        ruleForm
                    );
                    this.btnLoading = false;
                    if (resp.data.code === 200) {
                        // this.$message.success("提交成功");
                        this.respCode = resp.data.data.dwbh;
                        this.dialogVisible = true;
                    } else {
                        this.$message.error(resp.data.msg);
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        selectCascader() {
            this.ruleForm.regionStr = this.$refs["refRegion"]
                .getCheckedNodes()[0]
                .pathLabels.join(",");
            let xzqhBm = this.ruleForm.region;
            if (xzqhBm) {
                this.ruleForm.province = xzqhBm[0];
                this.ruleForm.city = xzqhBm[1];
                this.ruleForm.county = xzqhBm[2];
            }
        },
		selectCascaderTrain() {
		    this.trainForm.regionStr = this.$refs["refRegionTrain"]
		        .getCheckedNodes()[0]
		        .pathLabels.join(",");
		    let xzqhBm = this.trainForm.region;
		    if (xzqhBm) {
		        this.trainForm.province = xzqhBm[0];
		        this.trainForm.city = xzqhBm[1];
		        this.trainForm.county = xzqhBm[2];
		    }
		},
        searchHandle(e) {
            this.btnLoading = true;
            this.$post(
                    `visitor/joinxh/findCompany`,
                    this.searchForm
                )
                .then((resp) => {
                    this.btnLoading = false;
                    if (resp.data.code === 200) {
                        // this.$message.success("提交成功");
                        let tyshxydm = resp.data.data.tyshxydm;
						window.open("prod-api/visitor/dowloadCert/"+tyshxydm, "_blank");
                    } else {
                        this.$message.error(resp.data.msg);
                    }
                })
                .catch(() => {
                    this.btnLoading = false;
                });
        },
        goBack() {
            this.dialogVisible = false;
            // 跳转到指定的 URL 地址
            location.href = " http://www.sdampc.com/";
        },
        handleClick(e) {
		},
    },
};
</script>

<style scoped lang='scss'>
.headee {
    height: 100px;
    width: 100%;
    background: #fff;
    display: flex;
    align-items: center;
    .h-i {
        height: 76px;
    }
    .i100 {
        height: 54px;
        margin-right: 10px;
    }
    .phone {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        font-size: 18px;
        color: #4874cb;
        line-height: 26px;
    }
}
.bgg {
    width: 100%;
    position: relative;
    .ml-120 {
        position: absolute;
        z-index: 100;
        left: 120px;
        top: 10px;
        width: 400px;
        color: #fff;
        font-weight: bold;
        display: flex;
        flex-direction: column;
        p {
            text-align: left;
        }
    }
    .title {
        font-family: "微软雅黑 Bold", "微软雅黑";
        font-weight: 700;
        font-style: normal;
        font-size: 42px;
        color: #ffffff;
        line-height: 52px;
        margin-bottom: calc(50px + 40px);
        position: relative;
        z-index: 100;
    }
    .blue {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 524px;
        background-color: rgba(0, 121, 254, 0.905882352941176);
    }
    .img-bg {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 524px;
    }
    .img-bg-line {
        position: absolute;
        top: 434px;
        left: 0;
        z-index: 3;
        width: 100%;
        height: 90px;
    }
}
.aaaa {
    width: 200px;
}
.bottomm {
    width: 100%;
    height: 150px;
    background: #333333;
    color: #999999;
    .aasdas {
        display: flex;
        align-items: center;
    }
    .aln {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    .er-code-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-family: "微软雅黑";
        font-weight: 400;
        font-style: normal;
        font-size: 16px;
        color: #7f7f7f;
        line-height: 20px;
        margin-left: 10px;
        .er-code {
            width: 80px;
            margin-bottom: 5px;
        }
    }
}
.flex {
    display: flex;
    align-items: center;
}
.relative {
    position: relative;
    padding-top: 100px;
    margin-bottom: 50px;
}
.white {
    background: #fff;
    margin: 0 65px;
    padding: 30px;
    box-shadow: 0px 0px 5px rgba(51, 51, 51, 0.349019607843137);
    position: relative;
    z-index: 100;
    position: relative;
}
.center {
    text-align: center;
}
.content {
    margin: 0 auto;
    width: 900px;
}
.a1 {
    font-weight: bold;
    font-size: 28px;
    line-height: 80px;
}
.a2 {
    font-weight: 500;
    font-size: 18px;
    span {
        font-weight: bold;
        color: #000;
    }
}
.a3 {
    line-height: 60px;
}
.mt-40 {
    // margin-top: 40px;
}
::v-deep .tabss {
    position: absolute;
    top: -40px;
    left: 0;
    background: #fff;
}
.w-710 {
    width: 710px;
    height: 471.39344px;
    background: skyblue;
    background: url("../assets/images/certificate.jpg") no-repeat;
    background-size: contain;
    position: relative;
}
.mt-30{
    margin-top: 30px;
}
.trains-no-data{
    font-size: #000;
    font-size: 30px;
    text-align: center;
    line-height: 200px;
    min-height: 200px;
    user-select: none;
}
</style>